// index file of billing section on profile

import AddPaymentMethod from "../plans/AddPaymentMethod";
import PlanTeam from "../plans/Team";
import MyPlan from "./MyPlan";
let team=null;
if(document.querySelector('#profile-team-members-button')){
    team=new PlanTeam();
}                  
const myPlan=new MyPlan(team);

myPlan.load();
const paymentMethod=new AddPaymentMethod(myPlan);